
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18.779","height":"14.78"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('path',{staticClass:"a",attrs:{"d":"M18.154 2.3a2.019 2.019 0 00-1.482-.625h-2.963v-.036a1.6 1.6 0 00-.482-1.16 1.633 1.633 0 00-1.16-.482H6.712a1.646 1.646 0 00-1.66 1.642v.036H2.106A2.019 2.019 0 00.625 2.3 2.122 2.122 0 000 3.784v8.889a2.019 2.019 0 00.625 1.482 2.122 2.122 0 001.482.625h14.565a2.019 2.019 0 001.482-.625 2.122 2.122 0 00.625-1.482V3.784a2.019 2.019 0 00-.625-1.484zm-.3 10.371h-.018a1.158 1.158 0 01-1.16 1.16H2.106a1.158 1.158 0 01-1.16-1.16V3.784a1.158 1.158 0 011.16-1.16h3.445a.48.48 0 00.482-.482v-.518a.672.672 0 01.7-.7h5.337a.672.672 0 01.7.7v.518a.48.48 0 00.482.482h3.438a1.158 1.158 0 011.16 1.16z"}}),_c('path',{staticClass:"a",attrs:{"d":"M9.389 3.838a4.388 4.388 0 103.106 1.285 4.4 4.4 0 00-3.106-1.285zm2.428 6.837a3.448 3.448 0 01-4.855 0 3.413 3.413 0 01-1-2.428 3.488 3.488 0 011-2.428 3.412 3.412 0 012.428-1 3.488 3.488 0 012.428 1 3.412 3.412 0 011 2.428 3.34 3.34 0 01-1.001 2.428z"}}),_c('circle',{staticClass:"a",attrs:{"cx":".875","cy":".875","r":".875","transform":"translate(14.869 3.82)"}})])])
          )
        }
      }
    